import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSiteCategory from '../useSiteCategory';

const SingleSiteCategory = () => {
  const { t } = useTranslation();
  const { singleData, loading, companyCategories } = useSiteCategory(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const dataKeys = [
    { key: 'title_it', text: t('Titolo (Italiano)') },
    { key: 'title_en', text: t('Titolo (Inglese)') },
    { key: 'title_fr', text: t('Titolo (Francese)') },
    { key: 'company_category_id', text: t('Categorie insegne') },
  ];

  const getFieldValue = (key) => {
    const value = singleData?.[key];
    if (key === 'company_category_id') {
      const categoryFromFilters = companyCategories?.find(
        (item) => String(item.id || item.value) === String(value),
      );
      return (
        categoryFromFilters?.title ||
        singleData?.company_category?.title ||
        value
      );
    }
    return value;
  };

  const title = isSuccessUpdatePage
    ? t('SITE CATEGORY WAS SUCCESSFULLY UPDATED.')
    : t('SITE CATEGORY');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <List
            header={<div>{t('SITE CATEGORY')}</div>}
            dataSource={dataKeys}
            renderItem={(item) => (
              <List.Item>
                <b className={styles.itemName}>{item.text}</b>
                {getFieldValue(item.key)}
              </List.Item>
            )}
          />
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/site_categories/${singleData?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/site_categories'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleSiteCategory;
